// Upload helper for files (UPI screenshots, inspection photos, A4 photos).
// Returns the storage path. Use srcForPath() to render the image in <img>.
import { API_URL } from '@/lib/api';

const token = () => localStorage.getItem('auth_token');

export async function uploadFile(folder, file) {
  const fd = new FormData();
  fd.append('folder', folder);
  fd.append('file', file);
  const res = await fetch(`${API_URL}/api/files/upload`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token()}` },
    body: fd,
  });
  if (!res.ok) {
    let msg = 'Upload failed';
    try { msg = (await res.json()).detail || msg; }
    catch (e) { console.warn('Upload error had non-JSON body:', e?.message || e); }
    throw new Error(msg);
  }
  return (await res.json()).path;
}

// Build a viewable URL for an <img src>. If the value is already a base64 data URL
// (legacy data) or http(s) URL, return as-is. Otherwise route through the auth proxy.
export function srcForPath(p) {
  if (!p) return '';
  if (p.startsWith('data:') || p.startsWith('http')) return p;
  const t = token() || '';
  return `${API_URL}/api/files/${p}?auth=${encodeURIComponent(t)}`;
}

// Client-side compression for property photographs.
// Resizes to maxW px, encodes as JPEG @ given quality. Returns a Blob.
export function compressImage(file, maxW = 1600, quality = 0.78) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const ratio = img.height / img.width;
        const w = Math.min(maxW, img.width);
        const h = Math.round(w * ratio);
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        canvas.toBlob((blob) => {
          if (!blob) return reject(new Error('Compression failed'));
          resolve(new File([blob], (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', quality);
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
